import { cn } from '@utils/cn';
import { buttonVariants, type ButtonProps } from '@common/interaction/Button';

export type ButtonColor = ButtonProps['color'];

type ExternalButtonProps = {
  buttonColor?: ButtonColor;
  children: React.ReactNode;
  href: string;
  target: string;
};

export function ExternalButton({ children, href, target }: ExternalButtonProps) {
  return (
    <a
      className={cn(buttonVariants({ variant: 'contained', color: 'primary', size: 'lg' }))}
      href={href}
      target={target}
    >
      {children}
    </a>
  );
}
